import { useState, useEffect } from "react";
import { Card, CardHeader, Col, Container, Row, Button } from "reactstrap";

import { HomeCover } from "../../../../models/homeCoverDto";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import { HomeCoverImage } from "../../../../models/homeCoverImagesDto";
import CoverModal from "../../../../shared/cover-modal/cover-modal";
import styles from "./trainingPathCover.module.scss";
import Cover from "../../../../shared/cover/cover";
import SpinnerComponent from "../components/spinnerComponent";

const TrainingPathCover: React.FC = () => {
  const httpClient = useHttpClient(true);
  const [carouselItems, setCarouselItems] = useState([]);
  const [homeCover, setHomeCover] = useState<HomeCover>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isCoverModalOpened, setIsCoverModalOpened] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);

  const insertCarouselItems = (images: Array<HomeCoverImage>) => {
    setCarouselItems([]);
    let items = [];
    for (let image of images) {
      items.push({
        src: image.url,
        altText: "Slide",
        caption: "Slide",
      });
      setCarouselItems(items);
    }
  };

  useEffect(() => {
    if (!homeCover || !isDone) {
      getHomeCover();
    } else if (homeCover.id && homeCover.type === "CAROUSEL") {
      insertCarouselItems(homeCover.homeCoverImages);
    }
    // TODO check is more deps are needed
    // eslint-disable-next-line
  }, [homeCover]);

  const getHomeCover = () => {
    setIsDone(false);
    httpClient.current
      ?.get(`/homeCover`)
      .then(response => {
        setHomeCover(response.data);
        (response.data?.homeCoverImages as HomeCover[]).length === 0 ? setIsEmpty(true) : setIsEmpty(false);
        setIsLoading(false);
        setIsDone(true);
      })
      .catch(err => {
        if (err.response.status === 500) {
          setIsDone(true);
          setIsEmpty(true);
        }
      });
  };

  return (
    <Container className={styles["training-list-container"]} fluid>
      <Row>
        <Col sm="12">
          <Card className={styles["card-wrapper"]}>
            <CardHeader className={styles["training-card-header"]}>
              <Button outline color="success" className="float-right" onClick={() => setIsCoverModalOpened(!isCoverModalOpened)}>
                Changer la couverture
              </Button>
            </CardHeader>
            {!isDone ? (
              <SpinnerComponent />
            ) : !isEmpty ? (
              <Row>
                <Col sm="12" lg="12" xl="12" className={styles["cover-wrapper"]}>
                  {!isLoading && <Cover homeCover={homeCover} carouselItems={carouselItems} />}
                </Col>
              </Row>
            ) : (
              <Container className={styles["message_container"]}>
                <p className={styles["empty_courses_message"]}>{"Veuillez ajouter une couverture"}</p>
              </Container>
            )}
            <CoverModal setIsDone={setIsDone} coverModalState={isCoverModalOpened} setIsCoverModalOpened={setIsCoverModalOpened} setHomeCover={setHomeCover} />
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TrainingPathCover;
